import 'react-quill/dist/quill.snow.css'
import './quill.snow.extra.css'
import './custom.css'

import { Button } from 'antd'
import { FormBuilderContext } from 'pages/Contexts/FormBuilderContext'
import * as React from 'react'
import useBuilderQuestion from 'utils/FormBuilder/hooks/useBuilderQuestion'

import { TextEditor } from '@/components/TextEditor'
import Modal from '@/ui/Modal'

function BuilderDescriptionQuestionModalQuill() {
  const { selectedItem, setQuestion, setIsEditingDescription } =
    React.useContext(FormBuilderContext)

  const question = useBuilderQuestion(selectedItem.id)

  const [value, setValue] = React.useState(question?.text ?? '')
  const [isSaving, setIsSaving] = React.useState(false)

  const onCancel = React.useCallback(() => {
    setIsEditingDescription(false)
  }, [setIsEditingDescription])

  function onSaveDescriptionQuestionText() {
    setIsSaving(true)
    try {
      setQuestion(selectedItem.id, {
        ...question,
        text: value,
      })
      setIsEditingDescription(false)
    } catch (error) {
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <Modal
      open
      footer={
        <div className="my-3 flex justify-end gap-2">
          <Button onClick={onCancel}>Cancel</Button>
          <Button
            disabled={isSaving}
            loading={isSaving}
            onClick={onSaveDescriptionQuestionText}
            type="primary"
          >
            Save
          </Button>
        </div>
      }
      onCancel={onCancel}
      onClose={onCancel}
      title="Edit description"
      width={{
        xs: '90%',
        sm: '90%',
        md: '90%',
        lg: '75%',
        xl: '65%',
        xxl: '40%',
      }}
    >
      <TextEditor
        className="mt-4"
        onChange={setValue}
        tools={[
          'bold',
          'italic',
          'strike',
          'underline',
          'bulletList',
          'orderedList',
          'link',
          'image',
          'left',
          'center',
          'right',
          'table',
          'size',
          'color',
          'highlight',
        ]}
        value={value}
      />
    </Modal>
  )
}

export default BuilderDescriptionQuestionModalQuill
